export default "__VITE_ASSET__BUq7qdE9__"